module.exports = __webpack_public_path__ + "static/img/4.ed8e395.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/eng/4.png
// module id = ARKm
// module chunks = 0